/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_attributes_screen_resolution = /** @type {(inputs: {}) => string} */ () => {
	return `Rozlišení`
};

const da_attributes_screen_resolution = /** @type {(inputs: {}) => string} */ () => {
	return `Résolution`
};

const de_attributes_screen_resolution = /** @type {(inputs: {}) => string} */ () => {
	return `Bildschirmauflösung`
};

const en_attributes_screen_resolution = /** @type {(inputs: {}) => string} */ () => {
	return `Résolution`
};

const es_attributes_screen_resolution = /** @type {(inputs: {}) => string} */ () => {
	return `resolución de pantalla`
};

const fr_attributes_screen_resolution = /** @type {(inputs: {}) => string} */ () => {
	return `Résolution`
};

const hu_attributes_screen_resolution = /** @type {(inputs: {}) => string} */ () => {
	return `Résolution`
};

const it_attributes_screen_resolution = /** @type {(inputs: {}) => string} */ () => {
	return `Risoluzione dello schermo`
};

const nl_attributes_screen_resolution = /** @type {(inputs: {}) => string} */ () => {
	return `Schermresolutie`
};

const pl_attributes_screen_resolution = /** @type {(inputs: {}) => string} */ () => {
	return `Rozdzielczość ekranu`
};

const pt_attributes_screen_resolution = /** @type {(inputs: {}) => string} */ () => {
	return `Resolução do ecrã`
};

const sv_attributes_screen_resolution = /** @type {(inputs: {}) => string} */ () => {
	return `Upplösning på skärmen`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const attributes_screen_resolution = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.attributes_screen_resolution(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("attributes_screen_resolution", locale)
	if (locale === "cs") return cs_attributes_screen_resolution(inputs)
	if (locale === "da") return da_attributes_screen_resolution(inputs)
	if (locale === "de") return de_attributes_screen_resolution(inputs)
	if (locale === "en") return en_attributes_screen_resolution(inputs)
	if (locale === "es") return es_attributes_screen_resolution(inputs)
	if (locale === "fr") return fr_attributes_screen_resolution(inputs)
	if (locale === "hu") return hu_attributes_screen_resolution(inputs)
	if (locale === "it") return it_attributes_screen_resolution(inputs)
	if (locale === "nl") return nl_attributes_screen_resolution(inputs)
	if (locale === "pl") return pl_attributes_screen_resolution(inputs)
	if (locale === "pt") return pt_attributes_screen_resolution(inputs)
	return sv_attributes_screen_resolution(inputs)
};
export { attributes_screen_resolution as "attributes.screen_resolution" }